module.exports = __webpack_public_path__ + "static/media/md-create.d93204ce.svg";